import { useEffect, useState, useRef } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import DispensaryObservation from "./pages";
import keycloak from "./keycloak";
import axios from "axios";
import api from "./api";

import Box from "@mui/material/Box";
const getUserInfoURL = "user/userinfo";
const logoutURL = process.env.REACT_APP_PORTAL as string;

const App = () => {
  const didInit = useRef(false);
  const refreshIntervalRef = useRef<ReturnType<typeof setInterval>>();
  const [loggedIn, setLoggedIn] = useState(false);
  const [autorizedPerson, setAutorizedPerson] = useState(
    localStorage.getItem("fioAndOrganization"),
  );

  const { pathname } = useLocation();

  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;

    keycloak
      .init({ onLoad: "login-required" })
      // @ts-ignore
      .then((authenticated) => {
        setLoggedIn(authenticated);
        if (!authenticated) {
          keycloak.login();
        }

        // Периодическая проверка и рефреш токена
        refreshIntervalRef.current = setInterval(() => {
          keycloak
            .updateToken(70)
            .then((refreshed: boolean) => {
              if (refreshed) {
                console.log("Токен обновлен")
              }
            })
            .catch(() => {
              // token expired — логаутим
              localStorage.clear();
              keycloak.login();
            });
        }, 30000);
      });

    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (loggedIn) {
      api
        .get(getUserInfoURL)
        .then((data) => {
          localStorage.setItem(
            "fioAndOrganization",
            "ФИО: " +
              data.data.name +
              " " +
              data.data.surname +
              " " +
              data.data.patronymic +
              " Организация: " +
              data.data.organizationName,
          );
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            // interceptor already handles refresh/logout
          }
        });
    }
  }, [loggedIn]);

  if (!loggedIn) {
    return <div>Загрузка...</div>;
  }

  const getFioAndOrganization = (fioAndOrganization: string) =>
    setAutorizedPerson(fioAndOrganization);

  return (
    <Box>
      <Routes>
        <Route
          path="/"
          element={
            loggedIn ? (
              <DispensaryObservation
                getFioAndOrganization={getFioAndOrganization}
              />
            ) : (
              <Navigate to={logoutURL} />
            )
          }
        />
      </Routes>
    </Box>
  );
};

export default App;
